export default __webpack_public_path__ + "static/media/sticker.ebd7eda5.png";